/** Helpers de presentación para informes operativos (datos en vivo vía Cloud Function). */

export const FIRESTORE_FREE = {
  readsPerDay: 50_000,
  writesPerDay: 20_000,
};

export const FIRESTORE_PROJECT_NOTE =
  "Cuota Spark compartida entre Website, Academia y SIGMO en el proyecto agdysa-52935.";

export function fmtNum(n) {
  return Number(n ?? 0).toLocaleString("es-SV");
}

export function canAccessInformes(profile) {
  return (
    !!profile &&
    profile.status === "active" &&
    (profile.role === "admin" || profile.role === "owner")
  );
}

/** Proyección lecturas/día según eventos operativos del mes (heurística). */
export function estimateReadsPerDay(eventosMes, readsPerEvent) {
  const perDay = (Number(eventosMes) / 30) * readsPerEvent;
  return Math.round(perDay);
}

export function pctQuota(readsPerDay) {
  return Math.round((readsPerDay / FIRESTORE_FREE.readsPerDay) * 1000) / 10;
}

export const READS_HEURISTIC = {
  website: { typical: 5, label: "lecturas / lead o queja (CMS público)" },
  academia: { typical: 18, label: "lecturas / inscripción o sesión LMS" },
  medicina: { typical: 30, label: "lecturas / evento clínico" },
};
